import React from 'react';
import { Table } from 'react-bootstrap';
import { isResultPass, getTestPassedTitle } from 'helpers/RequestTestsHelper';
import { formatDate } from 'helpers/DateHelper';
import UploadedResults from 'containers/testResult/UploadedResults';
import FccidForm from 'containers/testResult/FccidForm';

const UnderReviewView = ({ show, testModule }) => {
  if (!show) return null;

  const startDate = formatDate(testModule.actualstartdate);
  const endDate = formatDate(testModule.actualenddate);
  const passed = isResultPass(testModule.requesttestpassedstatusid);

  return (
    <div>
      <FccidForm />
      <Table responsive>
        <thead>
          <tr>
            <th>Test Result</th>
            <th>Test Plan Version</th>
            {passed && [
              <th key={1}>Test Start Date</th>,
              <th key={2}>Test End Date</th>
            ]}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{getTestPassedTitle(testModule.requesttestpassedstatusid)}</td>
            <td>{testModule.planversion}</td>
            {passed && [
              <td key={3}>{startDate}</td>,
              <td key={4}>{endDate}</td>
            ]}
          </tr>
        </tbody>
      </Table>
      <UploadedResults reports={testModule.reports} />
    </div>
  );
};

export default UnderReviewView;



// WEBPACK FOOTER //
// ./src/containers/testResult/UnderReviewView.js